import { useEffect, useState } from 'react';

export function useEffectAfterInit(effect, deps) {
  let [inited, setInited] = useState(false);

  useEffect(() => {
    if (!inited) {
      setInited(true);
      return;
    }

    return effect();
  }, deps);
}
